import { render, staticRenderFns } from "./DeleteParticipantModal.vue?vue&type=template&id=3f056099&scoped=true"
import script from "./DeleteParticipantModal.vue?vue&type=script&lang=js"
export * from "./DeleteParticipantModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteParticipantModal.vue?vue&type=style&index=0&id=3f056099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f056099",
  null
  
)

export default component.exports